'use strict';

export class ParsingFunctions{
  public escapeHTML = ( value: string ): string => value
    .replace( /&/g, '&amp;' )
    .replace( /</g, '&lt;' )
    .replace( />/g, '&gt;' );

}
